import React, { FC } from 'react'

import s from './WixMobileContentWrapper.scss'

export const WixMobileContentWrapper: FC = ({ children }) => {
  return <div className={s.wrapper}>{children}</div>
}
